import * as d3 from "d3"
import { StyleBarState } from "app/core/components/sidebars/StyleBar"
import * as button from "./button"
import { SvgEventHandlers } from "./events/types"
import * as events from "./events"
import * as data from "./data"
import * as params from "./params"
import * as background from "./background"
import { ButtonDatum } from "./types"
import { Selection } from "d3-selection"
import { SvgData } from "app/core/components/dashboard/DashboardComponent"

export const dashboard = (): Selection<SVGSVGElement, never, HTMLElement, any> => {
  return d3.select<SVGSVGElement, never>("#svg-dashboard")
}

export const buttons = (): Selection<SVGGElement, ButtonDatum, SVGSVGElement, any> => {
  return d3
    .select<SVGSVGElement, never>("#svg-dashboard")
    .selectAll<SVGGElement, ButtonDatum>("g.playerdash-dashboard-button")
}

export const createButton = (
  buttonType: StyleBarState["buttonType"],
  initialX?: number,
  initialY?: number,
) => {
  const x = initialX ?? (30 + 50 * buttons().size()) % 1600
  const y = initialY ?? (30 + 50 * buttons().size()) % 900
  const createdButton = button.append(x, y)
  button.changeType(createdButton, buttonType)
  return createdButton
}

export const init = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
  editable?: boolean,
  showSelection?: boolean,
  allowMultiSelect?: boolean,
) => {
  background.append(d3.select(svgElement))
  data.computeFromAttributes()
  return events.configureHandlers(svgElement, handlers, editable, showSelection, allowMultiSelect)
}

export const saveableData = (): SvgData | undefined => {
  const dashboardNode = document.querySelector("#svg-dashboard")
  if (!dashboardNode) {
    return undefined
  }
  let svgDashboardId = dashboardNode.getAttribute("uuid")
  const clonedNode = dashboardNode?.cloneNode(true) as SVGSVGElement | undefined
  // remove button selection
  clonedNode
    ?.querySelectorAll("g.playerdash-dashboard-button")
    ?.forEach((node) => node?.classList?.remove("selected"))
  // remove alignment indicators
  clonedNode
    ?.querySelectorAll(".alignment-indicator")
    ?.forEach((node) => node?.parentNode?.removeChild(node))

  const data = clonedNode?.innerHTML
  return data ? { data, dashboardId: svgDashboardId ?? undefined } : undefined
}

export const nativeSvgElement = (): SVGSVGElement =>
  d3.select<SVGSVGElement, never>("#svg-dashboard").nodes()?.[0]

export const buttonsData = (): ButtonDatum[] =>
  d3
    .select<SVGSVGElement, never>("#svg-dashboard")
    .selectAll<SVGGElement, ButtonDatum>("g.playerdash-dashboard-button")
    .data()

export const scaleFactor = (): number => {
  return (nativeSvgElement()?.getBoundingClientRect()?.width ?? params.width) / params.width
}
